const OT = require('@opentok/client');
import * as React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { OTSession, OTPublisher, OTStreams, OTSubscriber } from 'opentok-react';
import CallEndIcon from '@material-ui/icons/CallEnd';
import Fab from '@material-ui/core/Fab';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    height: '55vh',
    minHeight: 320,
    '& .OTPublisherContainer': {
      width: '240px !important',
      height: '160px !important',
      position: 'absolute',
      bottom: 0,
      right: 0,
      border: 'solid 2px #333',
      zIndex: 2,
      [theme.breakpoints.down('sm')]: {
        width: '120px !important',
        height: '80px !important',
      }
    },
    '& .OTSubscriberContainer': {
      width: '100% !important',
      height: '55vh !important',
      minHeight: '320px !important',
    },
    '& .OT_archiving-status': {
      display: 'none'
    }
  },
  endCallButton: {
    position: 'absolute',
    left: 'calc( 50% - 28px )',
    bottom: 10,
    opacity: 0.4,
    '&:hover': {
      opacity: 1
    }
  },
  finishedMessage: {
    position: 'absolute',
    left: 0,
    top: '50%',
    marginTop: '-1em',
    color: '#fff',
    fontSize: '1.5em',
    textAlign: 'center',
    width: '100%',
  }
}));

export default function VideoChat(props) {
  const classes = useStyles();
  return(
    <div className={classes.root}>
      { props.finished ? <div className={classes.finishedMessage}>Video call has ended. Thank you.</div> : null }
      <OTSession apiKey={props.apiKey} sessionId={props.sessionId} token={props.token}>
        <OTPublisher />
        <OTStreams>
          <OTSubscriber className='OTSubscriberContainer OT_root OT_subscriber OT_fit-mode-contain' />
        </OTStreams>
      </OTSession>
      <Fab className={classes.endCallButton} color="secondary" aria-label="edit" onClick={() => props.onEndCall()}>
        <CallEndIcon />
      </Fab>
    </div>
  );
}
